(function() {
	PM.Absences = {};

	PM.Absences.renderPage = function() {
		PM.Shell.setSidebarActive('absences');
		PM.Shell.setBreadcrumb([{ label: i18next.t('Absences') }]);

		var range = PM.Weekly.getMonthRange();
		var fromMonth = range.fromMonth;
		var toMonth = range.toMonth;

		PM.Weekly.onMonthChange = PM.Absences.renderPage;

		$.when(
			$.get('/api/absences?fromMonth=' + fromMonth + '&toMonth=' + toMonth),
			ejs.preloadTemplate('/app/absences/templates/absences.ejs'),
			ejs.preloadTemplate('/app/absences/templates/absences-row.ejs')
		).done(function(absencesResult) {
			var data = absencesResult[0];
			PM.Absences._data = data;
			PM.Weekly.weekStructure = data.weekStructure;
			PM.Weekly.totalWeeks = data.weekStructure.totalWeeks;

			$('.js-page-container').html(
				ejs.rr('/app/absences/templates/absences.ejs', {
					people: data.people,
					fromMonth: fromMonth,
					toMonth: toMonth,
					weekStructure: data.weekStructure
				})
			);

			PM.Weekly.showZoomBar();
			PM.Weekly.initColumnResize('.js-absences-name', 'absences-col1-width');

			PM.Weekly._stripeApply = function() {
				$('.js-absences-table').addClass('js-weekly-stripe-mode');
				PM.Weekly.applyStripeColors('.js-absences-row', '.js-absences-week-input');
			};
			PM.Weekly._stripeRemove = function() {
				$('.js-absences-table').removeClass('js-weekly-stripe-mode');
				PM.Weekly.removeStripeColors('.js-absences-row', '.js-absences-week-input');
			};

			if (PM.Weekly.stripeMode) {
				PM.Weekly._stripeApply();
			}

			PM.Weekly.scrollToCurrentMonth('.js-weekly-zoom-container', data.weekStructure);
			PM.Weekly.highlightCurrentWeek('.js-weekly-zoom-container', data.weekStructure);
		});
	};

	// Keep data-raw-value in sync on input
	$(document).on('input', '.js-absences-week-input', function() {
		var val = $(this).val().trim();
		var parsed = val !== '' ? PM.Utils.parseNumber(val) : NaN;
		if (!isNaN(parsed)) {
			$(this).attr('data-raw-value', parsed).data('raw-value', parsed);
		} else {
			$(this).removeAttr('data-raw-value').removeData('raw-value');
		}
	});

	// Save on absences week input blur
	$(document).on('blur', '.js-absences-week-input', function() {
		var $input = $(this);
		var $row = $input.closest('.js-absences-row');
		var personId = $row.data('person-id');
		var absences = [];

		$row.find('.js-absences-week-input').each(function() {
			var rawVal = $(this).data('raw-value');
			var hours;
			if (rawVal !== undefined && rawVal !== '') {
				hours = parseFloat(rawVal);
			} else {
				var val = $(this).val().trim();
				hours = val !== '' ? PM.Utils.parseNumber(val) : NaN;
			}

			if (!isNaN(hours)) {
				absences.push({
					id: $(this).data('absence-id') || null,
					year: parseInt($(this).data('year')),
					week: parseInt($(this).data('per-year-week')),
					hours: hours
				});
			} else {
				var absenceId = $(this).data('absence-id');
				if (absenceId) {
					absences.push({
						id: parseInt(absenceId),
						year: parseInt($(this).data('year')),
						week: parseInt($(this).data('per-year-week')),
						hours: null
					});
				}
			}
		});

		if (absences.length === 0) return;

		$.ajax({
			url: '/api/absences',
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({ personId: personId, absences: absences })
		}).done(function(response) {
			if (response && response.absences) {
				response.absences.forEach(function(saved) {
					var $cellInput = $row.find(
						'.js-absences-week-input[data-per-year-week="' + saved.week + '"][data-year="' + saved.year + '"]'
					);
					$cellInput.attr('data-absence-id', saved.id).data('absence-id', saved.id);
					if (saved.hours !== undefined && saved.hours !== null) {
						$cellInput
							.val(i18next.format(saved.hours, 'number', i18next.language, { minimumFractionDigits: 2 }))
							.attr('data-raw-value', saved.hours)
							.data('raw-value', saved.hours);
					}
				});
			}
			PM.Absences.formatRow($row);
			if (PM.Weekly.stripeMode) {
				PM.Weekly.applyStripeColors('.js-absences-row', '.js-absences-week-input');
			}
		});
	});

	PM.Absences.exportCsv = function() {
		var data = PM.Absences._data;
		if (!data) return;

		var weekStructure = data.weekStructure;
		if (!weekStructure || !weekStructure.weeks) return;

		var personFilter = $('.js-absences-person-filter').val();

		var rows = [];
		rows.push(['Person', 'Year', 'Week', 'Hours']);

		for (var i = 0; i < data.people.length; i++) {
			var person = data.people[i];

			if (personFilter && String(person.id) !== personFilter) continue;

			var absencesByWeek = new Map();
			if (person.absences) {
				for (var a = 0; a < person.absences.length; a++) {
					var abs = person.absences[a];
					absencesByWeek.set(abs.globalWeek, (absencesByWeek.get(abs.globalWeek) || 0) + abs.hours);
				}
			}

			for (var wk = 0; wk < weekStructure.weeks.length; wk++) {
				var weekInfo = weekStructure.weeks[wk];
				var hours = absencesByWeek.get(weekInfo.weekNumber) || 0;
				if (hours === 0) continue;

				rows.push([
					person.name,
					String(weekInfo.year),
					String(weekInfo.perYearWeek),
					i18next.format(hours, 'number', i18next.language, { minimumFractionDigits: 2 })
				]);
			}
		}

		var csvContent = '\uFEFFsep=;\r\n';
		for (var r = 0; r < rows.length; r++) {
			var row = rows[r];
			var escaped = [];
			for (var c = 0; c < row.length; c++) {
				var cell = String(row[c]);
				if (cell.indexOf(';') !== -1 || cell.indexOf('"') !== -1 || cell.indexOf('\n') !== -1) {
					cell = '"' + cell.replace(/"/g, '""') + '"';
				}
				escaped.push(cell);
			}
			csvContent += escaped.join(';') + '\r\n';
		}

		var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		var url = URL.createObjectURL(blob);
		var link = document.createElement('a');
		link.href = url;
		link.download = 'absences_export.csv';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);

		new Notify({ status: 'success', text: i18next.t('CSV exported.'), timeout: 3000 });
	};

	PM.Absences.formatRow = function($row) {
		$row.find('.js-absences-week-input').each(function() {
			var $input = $(this);
			var rawVal = $input.data('raw-value');
			if (rawVal !== undefined && rawVal !== '' && !isNaN(parseFloat(rawVal))) {
				var hours = parseFloat(rawVal);
				$input.val(i18next.format(hours, 'number', i18next.language, { minimumFractionDigits: 2 }));
				$input.attr('data-raw-value', hours).data('raw-value', hours);
			}
		});
	};

	// Person filter change
	$(document).on('change', '.js-absences-person-filter', function() {
		var selectedId = $(this).val();
		if (selectedId === '') {
			$('.js-absences-row').show();
		} else {
			$('.js-absences-row').hide();
			$('.js-absences-row[data-person-id="' + selectedId + '"]').show();
		}
	});

	$(document).on('click', '.js-export-csv', function(e) {
		e.preventDefault();
		PM.Absences.exportCsv();
	});

	page('/absences', PM.Shell.routeWithPermission('view_plan', PM.Absences.renderPage));
	page.exit('/absences', function(ctx, next) {
		PM.Weekly.hideZoomBar();
		next();
	});
})();
